import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-support-redirect',
  template: ''
})
export class SupportRedirectComponent implements OnInit {
  ngOnInit(): void {
    window.location.replace('https://wa.me/beat22');
  }
}
